import React from "react";
import ErrorCodes from "../../common/errorCodes";

function ErrorCodesPage() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Error Codes</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">Docs</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Error Codes
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-12" style={{ position: "relative" }}>
                  <div className="card-body p-0">
                    <div className="p-5">
                      <ErrorCodes />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorCodesPage;
